/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { isFunction } from "../../Libs/CustomMethods/customMethods";
import "./AnimateWidth.scss";

const AnimateComponent = ({
  className,
  side,
  duration,
  children,
  initialIsOpen,
  onEndAnimation,
  onStartAnimation,
  trigger,
}) => {
  const isFirstRun = useRef(true);
  const componentRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isOpen, setIsOpen] = useState(initialIsOpen);

  const values = {
    className: className ?? "",
    side: side ?? "left",
    duration: duration ?? 500,
  };

  const animateIn = useCallback(() => {
    setIsAnimating(true);
    isFunction(onStartAnimation) && onStartAnimation("in");
    const { current } = componentRef;
    current?.classList?.remove("d-none");
    current?.classList?.remove("fade-out");
    current?.classList?.add("fade-in");
    return new Promise((resolve) =>
      setTimeout(() => {
        current?.classList?.remove("fade-in");
        setIsOpen(true);
        isFunction(onEndAnimation) && onEndAnimation("in");
        setIsAnimating(false);
        resolve();
      }, values.duration)
    );
  }, [values.duration]);

  const animateOut = useCallback(() => {
    setIsAnimating(true);
    isFunction(onStartAnimation) && onStartAnimation("out");
    const { current } = componentRef;
    current?.classList?.remove("fade-in");
    current?.classList?.add("fade-out");
    return new Promise((resolve) =>
      setTimeout(() => {
        current?.classList?.remove("fade-out");
        setIsOpen(false);
        isFunction(onEndAnimation) && onEndAnimation("out");
        setIsAnimating(false);
        resolve();
      }, values.duration)
    );
  }, [values.duration]);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (!isAnimating) {
      if (isOpen) {
        animateOut();
      } else {
        animateIn();
      }
    }
  }, [trigger]);

  return (
    <div
      ref={componentRef}
      className={`${values.className} animate-component ${values.side} ${
        !isOpen ? "d-none" : ""
      }`}
      style={{ animationDuration: `${values.duration / 1000}s` }}
    >
      {children}
    </div>
  );
};

export default AnimateComponent;
